export enum MailCallbackType {
    CREATE_SUBSCRIPTION = "CREATE_SUBSCRIPTION"
}

export interface MailCallbackRequestForUserPrompt {
    callbackType: MailCallbackType;
    params: Record<string, any>;
    validationResults: Record<string, any>;
}

export interface MailCallbackCallResponse {
    params: Record<string, any>;
}

export interface MailCallbackUserPrompt {
    params: Record<string, any>;
}
